import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Wallet, TrendingUp, TrendingDown, Gift } from 'lucide-react';
import { DualPrice } from '../DualPrice';

/**
 * Three top-of-dashboard summary tiles: Membership Unit Value, Current Value,
 * Referral Earnings. Pure presentational — receives the wallet doc and
 * `isPositiveGrowth` from the parent.
 */
export function StatsCards({ wallet, isPositiveGrowth }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
      <Card className="bg-[#041A3B] border-white/10" data-testid="total-value-card">
        <CardContent className="p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="w-10 h-10 rounded-lg bg-[#00E5FF]/10 flex items-center justify-center">
              <Wallet className="w-5 h-5 text-[#00E5FF]" />
            </div>
            {(wallet?.shares_count || 0) > 0 && (
              <span className="text-[#A0B4CC] text-[10px]">
                {Number(wallet?.shares_count || 0).toLocaleString('en-US', { maximumFractionDigits: 0 })} shares
              </span>
            )}
          </div>
          <p className="text-[#A0B4CC] text-sm mb-1">Membership Unit Value</p>
          <p className="font-outfit text-2xl font-semibold text-white">
            <DualPrice php={wallet?.initial_value || 0} phpDecimals={2} usdClassName="text-sm text-[#A0B4CC] font-normal ml-1" />
          </p>
        </CardContent>
      </Card>

      <Card className="bg-[#041A3B] border-white/10" data-testid="current-value-card">
        <CardContent className="p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="w-10 h-10 rounded-lg bg-[#00E676]/10 flex items-center justify-center">
              {isPositiveGrowth
                ? <TrendingUp className="w-5 h-5 text-[#00E676]" />
                : <TrendingDown className="w-5 h-5 text-[#FF1744]" />}
            </div>
          </div>
          <p className="text-[#A0B4CC] text-sm mb-1">Current Value</p>
          <p className="font-outfit text-2xl font-semibold text-white">
            <DualPrice php={wallet?.current_value || 0} phpDecimals={2} usdClassName="text-sm text-[#A0B4CC] font-normal ml-1" />
          </p>
        </CardContent>
      </Card>

      <Card className="bg-[#041A3B] border-white/10" data-testid="referral-earnings-card">
        <CardContent className="p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="w-10 h-10 rounded-lg bg-[#FFEA00]/10 flex items-center justify-center">
              <Gift className="w-5 h-5 text-[#FFEA00]" />
            </div>
          </div>
          <p className="text-[#A0B4CC] text-sm mb-1">Referral Earnings</p>
          <p className="font-outfit text-2xl font-semibold text-white">
            <DualPrice php={wallet?.referral_earnings || 0} phpDecimals={2} usdClassName="text-sm text-[#A0B4CC] font-normal ml-1" />
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
